import * as Yup from "yup";

const schema = Yup.object({
  name: Yup.string()
    .trim()
    .required("Name is required")
    .max(255, "Name is too long"),
  isActive: Yup.boolean(),
});

export default schema;
